import styles from "./SearchButton.module.css"
import { Search } from 'lucide-react';
import { useSearchWindow } from "../../../context/SearchContext";
/**
* A small Search button. Used in header.
* @returns TSX.Element
*/
const SearchButton = () => {
    const { isOpen, open, close } = useSearchWindow(); // Search window

    return(
        <>
            <button className={styles.Button} onClick={()=>isOpen === true ? close() : open() }>
                <Search/>
            </button>
        </>
    )
};

export default SearchButton;